// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#RecordingsManager .flexColumn {
    min-height: 100vh;
    width: 70vw;
    align-items: flex-start !important;
    padding-top: 50px;
}

#RecordingsManagerUserDropdownContainer {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
}

#RecordingsManager .titleText {
    margin-left: 0;
}

#RecordingsManager #recordingsList {
    display: grid;
    grid-gap: 20px;
    gap: 20px;
    margin-top: 20px;
}

#RecordingsManager #recordingsList .link {
    color: #1faeff;
    cursor: pointer;
    font-weight: bold;
}

#RecordingsManager #recordingsList .link:not(.active) {
    color: #ccc;
    pointer-events: none;
}

#RecordingsManager .recording.header {
    color: #1faeff;
    font-weight: bold;
    margin-top: 60px;
}

#RecordingsManager .recording {
    display: grid;
    grid-template-columns: 4fr 1fr 1fr 0.5fr 0.5fr 0.5fr;
    grid-gap: 10px;
    gap: 10px;
    opacity: 1;
    transition: opacity 1s ease;
}

#RecordingsManager .recording.willDelete {
    opacity: 0;
}

#RecordingsManager .recording>label {
    display: flex;
    align-items: center;
}

#RecordingsManager .recordingDescriptor {
    border-radius: 5px;
    padding: 2px 4px;
    margin: 0 3px;
    text-align: center;
}

#RecordingsManager .recordingDescriptor.blue {
    color: #1f96ff;
}

#RecordingsManager .recordingDescriptor.red {
    color: #f20000;
}

#RecordingsManager .recordingDescriptor.violet {
    color: #9300d6;
}

#RecordingsManager .recording .buttonsContainer {
    grid-column: span 3;
    display: flex;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Magor/RecordingsManager/index.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb","sourcesContent":["#RecordingsManager .flexColumn {\n    min-height: 100vh;\n    width: 70vw;\n    align-items: flex-start !important;\n    padding-top: 50px;\n}\n\n#RecordingsManagerUserDropdownContainer {\n    width: 100%;\n    position: fixed;\n    top: 0;\n    right: 0;\n    display: flex;\n    justify-content: flex-end;\n    padding: 10px;\n}\n\n#RecordingsManager .titleText {\n    margin-left: 0;\n}\n\n#RecordingsManager #recordingsList {\n    display: grid;\n    grid-gap: 20px;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n#RecordingsManager #recordingsList .link {\n    color: #1faeff;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n#RecordingsManager #recordingsList .link:not(.active) {\n    color: #ccc;\n    pointer-events: none;\n}\n\n#RecordingsManager .recording.header {\n    color: #1faeff;\n    font-weight: bold;\n    margin-top: 60px;\n}\n\n#RecordingsManager .recording {\n    display: grid;\n    grid-template-columns: 4fr 1fr 1fr 0.5fr 0.5fr 0.5fr;\n    grid-gap: 10px;\n    gap: 10px;\n    opacity: 1;\n    transition: opacity 1s ease;\n}\n\n#RecordingsManager .recording.willDelete {\n    opacity: 0;\n}\n\n#RecordingsManager .recording>label {\n    display: flex;\n    align-items: center;\n}\n\n#RecordingsManager .recordingDescriptor {\n    border-radius: 5px;\n    padding: 2px 4px;\n    margin: 0 3px;\n    text-align: center;\n}\n\n#RecordingsManager .recordingDescriptor.blue {\n    color: #1f96ff;\n}\n\n#RecordingsManager .recordingDescriptor.red {\n    color: #f20000;\n}\n\n#RecordingsManager .recordingDescriptor.violet {\n    color: #9300d6;\n}\n\n#RecordingsManager .recording .buttonsContainer {\n    grid-column: span 3;\n    display: flex;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
